import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useFlowchartStore } from '../../stores/flowchartStore';
import FlowchartTree from './FlowchartTree';
import styles from './FlowchartList.module.css';

export default function FlowchartList() {
  const { flowcharts, fetchFlowcharts } = useFlowchartStore();
  const [selectedFolder, setSelectedFolder] = useState<string>('/');
  const [folders, setFolders] = useState<string[]>([]);

  useEffect(() => {
    fetchFlowcharts();
  }, [fetchFlowcharts]);

  useEffect(() => {
    const uniqueFolders = new Set(flowcharts.map((f) => f.folder_path));
    setFolders(Array.from(uniqueFolders).sort());
  }, [flowcharts]);

  const filteredFlowcharts = selectedFolder
    ? flowcharts.filter((f) => f.folder_path === selectedFolder)
    : flowcharts;

  return (
    <div className={styles.container}>
      <div className={styles.sidebar}>
        <FlowchartTree 
          folders={folders}
          selectedFolder={selectedFolder}
          onSelectFolder={setSelectedFolder}
        />
      </div>

      <div className={styles.main}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <Link to="/" className={styles.backToDocs}>
              ← Back to Documents
            </Link>
            <h1 className={styles.title}>Flowcharts</h1>
          </div>
          <Link to="/flowcharts/new" className={styles.newButton}>
            + New Flowchart
          </Link>
        </div>

        {filteredFlowcharts.length === 0 ? (
          <div className={styles.emptyState}>
            <h2 className={styles.emptyStateTitle}>No flowcharts yet</h2>
            <p className={styles.emptyStateText}>
              Create your first interactive flowchart
            </p>
            <Link to="/flowcharts/new" className={styles.createLink}>
              Create Flowchart
            </Link>
          </div>
        ) : (
          <div className={styles.grid}>
            {filteredFlowcharts.map((flowchart) => (
              <Link
                key={flowchart.id}
                to={`/flowcharts/edit/${flowchart.slug}`}
                className={styles.card}
              >
                <h3 className={styles.cardTitle}>{flowchart.title}</h3>
                <div className={styles.cardMeta}>
                  <span className={styles.folder}>{flowchart.folder_path}</span>
                  <span className={styles.date}>
                    Updated: {new Date(flowchart.updated_at).toLocaleDateString()}
                  </span>
                </div>
                {flowchart.is_private && (
                  <span className={styles.privateBadge}>Private</span>
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
